const inputs = {
  username: {
    id: 'username',
    name: 'username',
    input: 'textField',
    label: 'login.form.username.label',
    placeholder: 'login.form.username.placeholder',
    rules: {
      required: { value: true },
    }
  },
  password: {
    id: 'pass',
    name: 'password',
    input: 'textField',
    type: 'password',
    placeholder: 'login.form.password.placeholder',
    label: 'login.form.password.label',
    rules: {
      required: { value: true },
    }
  },
  rememberMe: {
    id: 'rememberMe',
    name: 'rememberMe',
    input: 'checkbox',
    label: 'login.form.rememberMe.label'
  },
}

export default inputs;
